<div class="row mt-2" *ngIf="!showViewJourneyDetail">
  <div class="col">
    <small>
      <a [routerLink]="['/rental-fleet']" class="text-secondary">Admin Console </a>
      /<a [routerLink]="['/streaming']" class="text-secondary"> Streaming</a>
    </small>
  </div>
</div>

<div class="row mt-2" *ngIf="showViewJourneyDetail">
  <div class="col">
    <small>
      <a [routerLink]="['/rental-fleet']" class="text-secondary">Admin Console </a>
      /<a [routerLink]="['/streaming']" (click)="showViewJourneyDetail = false" class="text-secondary"> Streaming</a>
      /<a [routerLink]="['/journey']" (click)="showViewJourneyDetail = false" class="text-secondary"> Journey</a>
    </small>
  </div>
</div>

<div class="row pt-2" *ngIf="!showViewJourneyDetail">
  <div *ngIf="journeyData == null || journeyData.length < 1" class="col-sm-12 col-md text-center">
    <h3 class="text-muted">No Data Available</h3>
  </div>
  <div *ngIf="journeyData && journeyData.length > 0" class="table-responsive col-12 mt-3 pb-1">
    <!-- table-striped -->
    <table class="table table-striped tbl-scrollable">
      <thead class="thead-light">
        <tr>
          <td colspan="8" scope="col" class="font14-600">
            Journey Data
          </td>
        </tr>
        <tr>
          <th scope="col" width="14%" class="">Vehicle</th>
          <th scope="col" width="14%" class="text-right">Start Date</th>
          <th scope="col" width="14%" class="text-right">End Date</th>
          <th scope="col" width="15%" class="text-right">Start Location</th>
          <th scope="col" width="15%" class="text-right">End Location</th>
          <th scope="col" width="10%" class="text-right">Duration <span class="txt-small">(hrs)</span></th>
          <th scope="col" width="10%" class="text-right">MPG</th>
          <th scope="col" width="8%" class="text-right">Fuel <span class="txt-small">(gal)</span></th>
        </tr>
      </thead>
      <tbody class="max-height-57">
        <tr *ngFor="let journey of journeyData; let i = index">
          <!-- <th class=" text-center " scope="row">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="package_{{i}}"
                [disabled]="package.inUse || package.isActive" (change)="onPackageSelected(i)">
              <label class="custom-control-label" for="package_{{i}}"></label>
            </div>
          </th> -->
          <!-- <td class="d-none d-xl-table-cell pointer"
            (click)="onJourneyClicked(package)">
            {{journey.servicePackageId}}</td> -->
          <td width="14%" class="pointer" (click)="onJourneyClicked(journey)">{{journey.vin}}</td>
          <td width="14%" class="pointer text-right" (click)="onJourneyClicked(journey)">
            <span *ngIf="journey.startDate; else noStartDate">
              {{journey.startDate| date:'MM/dd/yyyy hh:mm'}}
            </span>
            <ng-template #noStartDate>
              Not Available
            </ng-template>
          </td>
          <td width="14%" class="pointer text-right" (click)="onJourneyClicked(journey)">
            <span *ngIf="journey.endDate; else noEndDate">
              {{journey.endDate| date:'MM/dd/yyyy hh:mm'}}
            </span>
            <ng-template #noEndDate>
              Not Available
            </ng-template>
          </td>
          <td width="15%" class="pointer text-right" (click)="onJourneyClicked(journey)">

            <span
              *ngIf="journey.startLocation && journey.startLocation.coordinate 
            && journey.startLocation.coordinate.latitude && journey.startLocation.coordinate.longitude ; else noStartLocation">
              <span>{{journey.startLocation.coordinate.latitude | number:'1.4-4'}}&deg;</span>,&nbsp;&nbsp;
              <span>{{journey.startLocation.coordinate.longitude| number:'1.4-4'}}&deg;</span>
            </span>
            <ng-template #noStartLocation>
              Not Available
            </ng-template>
          </td>
          <td width="15%" class="pointer text-right" (click)="onJourneyClicked(journey)">

            <span
              *ngIf="journey.endLocation && journey.endLocation.coordinate 
            && journey.endLocation.coordinate.latitude && journey.endLocation.coordinate.longitude ; else noEndLocation">
              <span>{{journey.endLocation.coordinate.latitude | number:'1.4-4'}}&deg;</span>,&nbsp;&nbsp;
              <span>{{journey.endLocation.coordinate.longitude | number:'1.4-4'}}&deg;</span>
            </span>
            <ng-template #noEndLocation>
              Not Available
            </ng-template>
          </td>
          <td width="10%" class="pointer text-right" (click)="onJourneyClicked(journey)">
            <span *ngIf="journey.duration; else noDuration">
              <span *ngIf="(journey.duration < 60); else inHours;">
                <span *ngIf="(journey.duration >= 10); else inMins;">
                  0:{{journey.duration}}
                </span>
                <ng-template #inMins>
                  0:0{{journey.duration}}
                </ng-template>
              </span> &nbsp;
              <ng-template #inHours>{{(journey.duration/60) | intNumber }}:{{(journey.duration%60).toFixed(0)}}
              </ng-template>
            </span>
            <ng-template #noDuration>
              -
            </ng-template>
            <!-- <span>{{journey.endLocation.coordinate.longitude | number:'1.4-4'}}</span> -->
          </td>
          <td width="10%" class="pointer text-right" (click)="onJourneyClicked(journey)">
            <span *ngIf="journey.mileage; else noMileage">{{journey.mileage | number:'1.2-2'}}</span>
            <ng-template #noMileage>-</ng-template>
          </td>
          <td width="8%" class="pointer text-right" (click)="onJourneyClicked(journey)">
            <span>{{journey.fuelConsumption.value | number:'1.2-2'}}</span>
            <!-- <ng-template #noFuel>
              -
            </ng-template> -->
          </td>
        </tr>

        <!-- <td class="pointer" (click)="onJourneyClicked(package)">
            <span *ngIf="package.ratePlans[0].type=='SERVICE_RATE_PLAN'"> Default Service Rate Plan </span>
            <span *ngIf="package.ratePlans[0].type=='SERVICE_PACKAGE_RATE_PLAN'">
              {{package.ratePlans[0].ratePlanType}}
            </span>
          </td> --
          <td class="pointer" (click)="onJourneyClicked(package)">
            {{package.packageRatePlan.ratePlanType | customText}}
          </td>
          <td class="pointer" (click)="onJourneyClicked(package)">
            <span *ngIf="package.inUse || package.isActive">In-Use</span>
            <span *ngIf="!package.inUse && !package.isActive ">Not-In-Use</span>
          </td>
        </tr> -->
      </tbody>
    </table>
  </div>
</div>


<div *ngIf="showViewJourneyDetail">
  <app-view-journey-detail [journeyDetail]="selectedJourney" (closeEmitter)="closeOfViewClicked($event)">
  </app-view-journey-detail>
</div>